import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, Redirect } from "react-router-dom";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Modal, Button, Form } from "react-bootstrap";
import { excelToJson } from "../../../utils/excelToJson";
import { connect } from "react-redux";
import {
  loadClassroomsList,
  clearClassroom,
  updateClassroom,
  deleteClassroom,
  addClassroom,
  loadSchoolsList,
  loadUsersList,
  deleteClassroomStudent,
  addClassroomStudent,
  addClassroomStudents,
  validateUser,
} from "../../../actions/admin";
import { setAlert } from "../../../actions/alerts";
import PropTypes from "prop-types";
import ClassroomFormStudents from "./ClassroomFormStudents";
import YearDropDown from "../../layouts/YearDropDown";
import MultiSelectWithCheckboxes from "../../layouts/MultiSelect";

const ClassroomForm = ({
  clearClassroom,
  updateClassroom,
  addClassroom,
  deleteClassroom,
  schoolsList,
  classroom,
  user,
  schoolListLoading,
  loadSchoolsList,
  loadUsersList,
  loadClassroomsList,
  usersList,
  usersListLoading,
  classroomLoading,
  deleteClassroomStudent,
  addClassroomStudent,
  addClassroomStudents,
  validateUser,
  setAlert,
  schoolYears,
}) => {
  const hist = useHistory();
  const location = useLocation();

  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(false);
  const [studentsList, setStudentsList] = useState([]);
  const [uploadedStudents, setUploadedStudents] = useState([]);
  const [student, setStudent] = useState(-1);
  const [isBulkUpload, setIsBulkUpload] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({});
  const [isLoadingValidateForm, setIsLoadingValidateForm] = useState(false);
  const typeaheadRef = useRef(null);

  useEffect(() => {
    if (location.pathname.includes("add")) {
      setFormData({
        Section: "",
        Remarks: "",
        GradeID: -1,
        TeacherID: "",
        SecondaryTeacherID: null,
        Year: schoolYears?.endYear || new Date().getFullYear() + 1,
        SchoolID: user.SchoolID !== null ? user.SchoolID : "",
        Students: [],
        ClassroomID: null,
      });
      setStudentsList([]);
      setUploadedStudents([]);
      setFile(null);
      // setIsBulkUpload(false);
    } else if (location.pathname.includes("edit")) {
      if (classroom) {
        setIsBulkUpload(false);
        setFormData({
          Section: classroom.Section || "",
          Remarks: classroom.Remarks || "",
          GradeID: classroom.GradeID || -1,
          TeacherID: classroom.TeacherID || "",
          SecondaryTeacherID: classroom.SecondaryTeacherID || null,
          Year:
            classroom.Year ||
            schoolYears?.endYear ||
            new Date().getFullYear() + 1,
          SchoolID: classroom.SchoolID || "",
          Students: classroom.Students || [],
          ClassroomID: classroom.ClassroomID || null,
        });
      }
    }
  }, [user]);
  useEffect(() => {
    if (!classroomLoading && location.pathname.includes("edit")) {
      setList(classroom.Students);
    }
  }, [classroomLoading, classroom, setList]);

  useEffect(() => {
    if (schoolsList.length === 0 && schoolListLoading) {
      loadSchoolsList();
    }
    // if (usersList.length === 0 && usersListLoading) {
    //   loadUsersList();
    // }
  }, [
    schoolsList,
    loadSchoolsList,
    schoolListLoading,
    usersListLoading,
    loadUsersList,
    usersList.length,
  ]);

  useEffect(() => {
    if (user.UserTypeID === 6) {
      loadUsersList();
    }
  }, [clearClassroom]);

  useEffect(() => {
    if (formData.SchoolID) {
      loadUsersList({ SchoolIDs: [formData.SchoolID] });
    }
  }, [formData.SchoolID]);

  const validateForm = async () => {
    setWarningMessage("");

    if (
      formData.SchoolID === undefined ||
      formData.SchoolID === null ||
      formData.SchoolID === "" ||
      formData.SchoolID === -1 ||
      formData.SchoolID === "-1"
    ) {
      setWarningMessage("School is required");
      setShowWarning(true);
      return false;
    }

    if (
      formData.TeacherID === undefined ||
      formData.TeacherID === null ||
      formData.TeacherID === "" ||
      formData.TeacherID === -1 ||
      formData.TeacherID === "-1"
    ) {
      setWarningMessage("Teacher is required");
      setShowWarning(true);
      return false;
    }

    if (
      formData.Year === undefined ||
      formData.Year === null ||
      formData.Year === "" ||
      formData.Year === -1 ||
      formData.Year === "-1"
    ) {
      setWarningMessage("Year is required");
      setShowWarning(true);
      return false;
    }

    if (
      formData.GradeID === undefined ||
      formData.GradeID === null ||
      formData.GradeID === "" ||
      formData.GradeID === -1 ||
      formData.GradeID === "-1"
    ) {
      setWarningMessage("Grade is required");
      setShowWarning(true);
      return false;
    }

    if (isBulkUpload && uploadedStudents.length === 0) {
      setWarningMessage("Please upload a valid student list file.");
      setShowWarning(true);
      return false;
    }

    if (isBulkUpload && uploadedStudents.length > 0) {
      for (let i = 0; i < uploadedStudents.length; i++) {
        if (
          !uploadedStudents[i].col_0 ||
          !uploadedStudents[i].col_1 ||
          !uploadedStudents[i].col_2
        ) {
          setWarningMessage(
            "Some rows in the uploaded file are missing required fields (First Name, Last Name, or Student ID). Please check the file and try again.",
          );
          setShowWarning(true);
          return false;
        }
      }
    }

    if (
      location.pathname.includes("add") &&
      !isBulkUpload &&
      formData.Students.length === 0
    ) {
      setWarningMessage("Please add at least one student.");
      setShowWarning(true);
      return false;
    }

    // Extra student's first name, last name and id to validate with levenshtein algorithm
    if (isBulkUpload && uploadedStudents.length > 0) {
      setIsLoadingValidateForm(true);
      await validateUser(uploadedStudents)
        .then((res) => {
          if (!res.success) {
            const newStudents = `${res.errors.Summary["NewStudents"]} New Student(s) 🔵`;
            const closeMatches = `${res.errors.Summary["CloseMatches"]} Close Match(es) 🔴`;
            const exactMatches = `${res.errors.Summary["ExactMatches"]} Exact Match(es) 🟢`;
            const exactMatchMessages =
              res.errors.Messages.exactMatches.join("\n");
            const closeMatchMessages =
              res.errors.Messages.closeMatches.join("\n");
            const unMatchMessages = res.errors.Messages.unMatches.join("\n");

            const consolidateMessages = `Summary of Classroom: \n${newStudents}\n${closeMatches}\n${exactMatches}\n\n${unMatchMessages}\n${closeMatchMessages}\n${exactMatchMessages}\n`;
            setIsLoadingValidateForm(false);
            setWarningMessage(consolidateMessages);
            return false;
          }
        })
        .catch(() => {
          setWarningMessage("Something went wrong");
        })
        .finally(() => {
          setIsLoadingValidateForm(false);
        });
    }
    return true;
  };

  const onChange = (e) => {
    // Handle Upload Student List Yes/No
    if (e.target.id === "uploadStudentListYes") {
      setIsBulkUpload(true);
      return;
    } else if (e.target.id === "uploadStudentListNo") {
      setIsBulkUpload(false);
      return;
    }

    // Handle Upload File
    if (e.target.id === "fileBulkUpload") {
      excelToJson(
        e.target.files[0],
        (uploadedStudents) => {
          setUploadedStudents(uploadedStudents);
          setFile(e.target.files[0]);
          setShowImportModal(false);
        },
        (error) => {
          setWarningMessage(error);
          setFile(null);
          setShowImportModal(false);
          setShowWarning(true);
        },
      );
      return;
    }

    setFormData({
      ...formData,
      [e.target.id]:
        e.target.id === "SecondaryTeacherID" && e.target.value === ""
          ? null
          : e.target.value,
    });
  };

  const checkForDuplicateStudents = (studentList) => {
    const currentSessionEnrolledStudents = usersList.filter(
      (user) =>
        user.UserTypeID === 2 &&
        user.SchoolID === parseInt(SchoolID) &&
        user.GradeID !== null &&
        user.Year === parseInt(Year),
    );

    const matchingStudents = currentSessionEnrolledStudents.filter((student) =>
      studentList.some((user) => user === student.UserID),
    );
    return matchingStudents;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);

    // Validate form first
    const isValid = await validateForm();
    if (!isValid) {
      return;
    }
    const matchingStudents = checkForDuplicateStudents(Students);
    if (matchingStudents.length > 0) {
      setWarningMessage(
        `The following student(s) are already enrolled in the current session. In order to add them, please remove them from the current classroom they are enrolled in:\n 🔴${matchingStudents.map((student) => `${student.FirstName} ${student.LastName}`).join("\n🔴")}`,
      );
      setShowWarning(true);
    } else {
      // Show confirmation modal instead of directly submitting
      setShowConfirmModal(true);
    }
  };

  const handleConfirmSubmission = async () => {
    try {
      if (location.pathname.includes("add")) {
        let data;

        if (isBulkUpload) {
          data = {
            ...formData,
            Students: [...new Set(Students)].filter((item) => item !== -1),
            uploadedStudents: uploadedStudents,
          };

          addClassroomStudents(data).then((res) => {
            if (res && res.length) {
              const msgStr = res.map((msg) => msg).join("\n");
              setWarningMessage(msgStr);
              setShowWarning(true);
              setShowConfirmModal(false);
              return;
            } else {
              hist.push("/admin/classrooms");
              clearClassroom();
              setShowConfirmModal(false);
              setFile(null);
              setUploadedStudents([]);
              setIsBulkUpload(false);
              setFormData({
                Section: "",
                Remarks: "",
                GradeID: -1,
                TeacherID: "",
                SecondaryTeacherID: null,
                Year: -1,
                SchoolID: -1,
                Students: [],
                ClassroomID: null,
              });
            }
          });
        } else {
          data = {
            ...formData,
            Students: [...new Set(Students)].filter((item) => item !== -1),
          };

          addClassroom(data).then(() => {
            hist.push("/admin/classrooms");
            clearClassroom();
            setShowConfirmModal(false);
            setFile(null);
            setUploadedStudents([]);
            setIsBulkUpload(false);
            setFormData({
              Section: "",
              Remarks: "",
              GradeID: -1,
              TeacherID: "",
              SecondaryTeacherID: null,
              Year: -1,
              SchoolID: -1,
              Students: [],
              ClassroomID: null,
            });
          });
        }
      } else if (location.pathname.includes("edit")) {
        updateClassroom(classroom.ClassroomID, formData).then(() => {
          hist.push("/admin/classrooms");
          clearClassroom();
          setShowConfirmModal(false);
          setFile(null);
          setUploadedStudents([]);
          setIsBulkUpload(false);
          setFormData({
            Section: "",
            Remarks: "",
            GradeID: -1,
            TeacherID: "",
            Year: -1,
            SchoolID: -1,
            Students: [],
            ClassroomID: null,
          });
        });
      }
    } catch (error) {
      console.error("Error saving classroom:", error);
      setWarningMessage("An error occurred while saving the classroom.");
      setShowWarning(true);
      setShowConfirmModal(false);
    }
  };

  const {
    Section,
    Remarks,
    GradeID,
    TeacherID,
    SecondaryTeacherID,
    Year,
    SchoolID,
    Students,
    ClassroomID,
  } = formData;

  const isSchoolSelected =
    SchoolID !== undefined &&
    SchoolID !== null &&
    SchoolID !== "" &&
    SchoolID !== -1 &&
    SchoolID !== "-1";

  if (classroom === null && location.pathname.includes("edit"))
    return <Redirect to="/admin/classrooms" />;

  return (
    <div className="p-sm-5 p-2 w-100  dashboard-margin mx-lg-auto container">
      <div className="mb-3 ">
        <h6 className="txt-primary-light">
          {user.UserType} / Classrooms / Classroom
        </h6>
        <div className="d-sm-flex  w-100 align-items-center justify-content-between">
          <div className="d-flex mb-2 mb-sm-0">
            <div
              className="admin-back mx-2  rounded-circle d-flex align-items-center justify-content-center txt-primary"
              onClick={() => {
                hist.goBack();
                setFormData({
                  Section: "",
                  Remarks: "",
                  GradeID: -1,
                  TeacherID: "",
                  SecondaryTeacherID: null,
                  Year: -1,
                  SchoolID: -1,
                  Students: [],
                  ClassroomID: null,
                });
                clearClassroom();
                setFile(null);
                setUploadedStudents([]);
                // setIsBulkUpload(false);
                setStudentsList([]);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                className="bi bi-arrow-left-short"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                />
              </svg>
            </div>
            <h4 className="m-0">
              {location.pathname.includes("add") ? "View" : "Edit"}
            </h4>
          </div>
        </div>
      </div>
      <form
        className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0  mb-2 "
        onSubmit={(e) => onSubmit(e)}
      >
        <div className="mb-3">
          <div className="txt-primary">Section</div>
          <input
            type="text"
            className="form-control rounded "
            id="Section"
            placeholder="Enter Section Name... (e.g., 2A, 2B)"
            value={Section}
            onChange={(e) => onChange(e)}
          />
        </div>
        {/*  Remarks */}
        <div className="mb-3">
          <div className="txt-primary">Remarks</div>
          <input
            type="text"
            className="form-control rounded "
            id="Remarks"
            placeholder="Enter Remarks..."
            value={Remarks}
            onChange={(e) => onChange(e)}
          />
        </div>
        {/* School */}
        {!schoolListLoading && user.SchoolID === null && (
          <div className="mb-3">
            <div className="txt-primary">School*</div>
            <select
              className="form-select"
              aria-label="Default select example"
              id="SchoolID"
              value={SchoolID}
              onChange={(e) => onChange(e)}
            >
              <option value={""}>Select School</option>
              {user.UserTypeID === 6
                ? schoolsList
                    .sort((a, b) => {
                      const nameA = a.Name;
                      const nameB = b.Name;

                      if (nameA < nameB) {
                        return -1;
                      }
                      if (nameA > nameB) {
                        return 1;
                      }
                      return 0;
                    })
                    .filter((school) =>
                      user.schoolIds
                        .split(",")
                        .map((id) => parseInt(id.trim()))
                        .includes(school.SchoolID),
                    )
                    .map((school) => {
                      return (
                        <option key={school.SchoolID} value={school.SchoolID}>
                          {school.Name}
                        </option>
                      );
                    })
                : schoolsList
                    .sort((a, b) => {
                      const nameA = a.Name;
                      const nameB = b.Name;

                      if (nameA < nameB) {
                        return -1;
                      }
                      if (nameA > nameB) {
                        return 1;
                      }
                      return 0;
                    })
                    .map((school) => {
                      return (
                        <option key={school.SchoolID} value={school.SchoolID}>
                          {school.Name}
                        </option>
                      );
                    })}
            </select>
          </div>
        )}
        {/* Teacher, Year, Grade */}
        {/* {isSchoolSelected && ( */}
        {
          <>
            <div className="mb-3">
              <div className="txt-primary">Teacher*</div>
              <select
                className="form-select form-control border-primary"
                aria-label="Default select"
                value={TeacherID}
                id="TeacherID"
                onChange={(e) => onChange(e)}
              >
                <option value={-1}>Select Teacher</option>
                {usersList
                  .filter(
                    (teacher) =>
                      teacher.UserTypeID === 1 &&
                      teacher.SchoolID === parseInt(SchoolID) &&
                      teacher.UserID !== parseInt(SecondaryTeacherID),
                  )
                  .map((teacher) => (
                    <option key={teacher.UserID} value={teacher.UserID}>
                      {teacher.FirstName} {teacher.LastName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="mb-3">
              <div className="txt-primary">Secondary Teacher (Optional)</div>
              <select
                className="form-select form-control border-primary"
                aria-label="Secondary Teacher"
                value={SecondaryTeacherID}
                id="SecondaryTeacherID"
                onChange={(e) => onChange(e)}
              >
                <option value="">Select Secondary Teacher</option>
                {usersList
                  .filter(
                    (teacher) =>
                      teacher.UserTypeID === 1 &&
                      teacher.SchoolID === parseInt(SchoolID) &&
                      teacher.UserID !== parseInt(TeacherID),
                  )
                  .map((teacher) => (
                    <option key={teacher.UserID} value={teacher.UserID}>
                      {teacher.FirstName} {teacher.LastName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="mb-3">
              <div className="txt-primary">Year*</div>
              <select
                className="form-select form-control border-primary"
                aria-label="Default select"
                value={Year}
                id="Year"
                onChange={(e) => onChange(e)}
              >
                <option value={-1}>Select Year</option>
                <YearDropDown schoolYears={schoolYears} />
              </select>
            </div>
            <div className="mb-3">
              <div className="txt-primary">Grade*</div>
              <select
                className="form-select form-control border-primary"
                aria-label="Default select example"
                value={GradeID}
                id="GradeID"
                onChange={(e) => onChange(e)}
              >
                <option value={-1}>Select Grade</option>
                <option value={7}>Kindergarten</option>
                <option value={1}>Grade 1</option>
                <option value={2}>Grade 2</option>
                <option value={3}>Grade 3</option>
                <option value={4}>Grade 4</option>
                <option value={5}>Grade 5</option>
                <option value={6}>Grade 6</option>
                <option value={8}>Grade 7</option>
                <option value={9}>Grade 8</option>
                <option value={10}>Other</option>
              </select>
            </div>
          </>
        }
        {/* Bulk Upload Selection*/}
        {/* {isSchoolSelected && */}
        {!location.pathname.includes("edit") && (
          <div className="d-flex flex-column gap-1 mb-3">
            <div className="txt-primary">Upload student list</div>
            {/* Radio Button Yes/No */}
            {!file && (
              <div className="d-flex gap-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="uploadStudentList"
                    id="uploadStudentListYes"
                    value="yes"
                    checked={isBulkUpload === true}
                    onChange={(e) => onChange(e)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="uploadStudentListYes"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="uploadStudentList"
                    id="uploadStudentListNo"
                    value="no"
                    checked={isBulkUpload === false}
                    onChange={(e) => onChange(e)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="uploadStudentListNo"
                  >
                    No
                  </label>
                </div>
              </div>
            )}

            {file && (
              <div className="d-flex align-items-center gap-2">
                <div>File Uploaded: {file ? file.name : ""} </div>
                <div
                  className={`align-self-end `}
                  onClick={() => {
                    setFile(null);
                    setUploadedStudents([]);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="37.6"
                    height="37.6"
                    fill="currentColor"
                    class="bi bi-trash delete-item-btn rounded-circle border  border-2 p-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
        )}
        {/* Normal Student Assignment */}
        {
          // !usersListLoading &&
          // isSchoolSelected &&
          !location.pathname.includes("edit") && !isBulkUpload && (
            <div className="mb-3">
              {/* <ClassroomFormStudents
                setFormData={setFormData}
                formData={formData}
                studentsList={usersList.filter(
                  (user) =>
                    user.UserTypeID === 2 &&
                    user.SchoolID === parseInt(SchoolID)
                )}
                setAlert={setAlert}
                edit={false}
              /> */}
              <MultiSelectWithCheckboxes
                id="Students"
                value={formData.Students || Students?.[0]?.UserID || []}
                optionsList={usersList
                  .filter(
                    (user) =>
                      user.UserTypeID === 2 &&
                      user.SchoolID === parseInt(SchoolID),
                  )
                  .map((user) => ({
                    value: user.UserID,
                    label: `${user.FirstName} ${user.LastName}`,
                  }))}
                placeholder={"Select Students"}
                formData={formData}
                setFormData={setFormData}
                isMulti={true}
                showSelectAll={true}
              />
            </div>
          )
        }
        {/* Bulk Student Assignment */}
        {/* && isSchoolSelected */}
        {!usersListLoading && isBulkUpload && !file && (
          <div className="d-flex gap-3">
            {/* Export Template */}
            <a
              href={
                process.env.PUBLIC_URL + "/templates/classroom_students.xlsx"
              }
              download
              className="btn button-parent button-primary d-flex align-items-center px-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-download button-child"
                viewBox="0 0 16 16"
              >
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
              </svg>
              Template
            </a>
            {/* Import Students */}
            <Button
              className="d-flex align-items-center px-3 button-primary"
              onClick={() => setShowImportModal(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                enableBackground="new 0 0 24 24"
                height="18px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#ffffff"
                className="button-child"
              >
                <g>
                  <rect fill="none" height="18" width="18" />
                </g>
                <g>
                  <g>
                    <path d="M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z" />
                  </g>
                </g>
              </svg>
              Import Excel
            </Button>
          </div>
        )}
        {location.pathname.includes("edit") && (
          <div className="my-3 w-80">
            <h6 className="txt-primary">Students Info</h6>
            {!isBulkUpload && (
              <div className="d-flex justify-content-end">
                <div
                  className="btn button-primary"
                  onClick={() => {
                    if (edit) {
                      setEdit(false);
                    } else {
                      let arr = [];
                      const initialStudentIDs = classroom.Students.map(
                        (s) => s.StudentID,
                      );
                      setStudentsList(initialStudentIDs);
                      //setStudentsList(arr);
                      loadUsersList({ SchoolIDs: [classroom.SchoolID] }).then(
                        () => {
                          setEdit(true);
                        },
                      );
                    }
                  }}
                >
                  {edit ? "Cancel" : "Edit"}
                </div>
              </div>
            )}
            {edit && !isBulkUpload && (
              <div className="d-flex my-3">
                <Typeahead
                  ref={typeaheadRef}
                  className="w-100 mx-2"
                  id="student"
                  /*defaultSelected={usersList
                    .filter(
                      (item) =>
                        item.UserTypeID === 2 &&
                        item.SchoolID === classroom.SchoolID,
                    )
                    .slice(0, 1)}*/
                  labelKey={(option) =>
                    `${option.FirstName} ${option.LastName}${
                      option.AlternativeID !== null
                        ? ` - ${option.AlternativeID}`
                        : ""
                    }`
                  }
                  onInputChange={(text, e) => {}}
                  onChange={(e) => {
                    if (e.length > 0) {
                      setStudent(e[0].UserID);
                    } else {
                      setStudent(-1);
                    }
                  }}
                  options={usersList.filter(
                    (item) =>
                      item.UserTypeID === 2 &&
                      item.SchoolID === classroom.SchoolID,
                  )}
                  placeholder="Please Select a Student"
                />
                {/*<select
                  className='form-select mx-2'
                  aria-label='Default select example'
                  id='Student'
                  value={student}
                  onChange={(e) => {
                    setStudent(parseInt(e.target.value));
                  }}
                >
                  <option value={-1}>Please Select a Student</option>
                  {usersList
                    .filter(
                      (item) =>
                        item.UserTypeID === 2 &&
                        item.SchoolID === classroom.SchoolID,
                    )
                    .map((student, id) => {
                      return (
                        <option value={student.UserID} key={id}>
                          {student.FirstName + ' ' + student.LastName}
                        </option>
                      );
                    })}
                  </select>*/}
                <button
                  className="btn button-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    if (studentsList.includes(student)) {
                      setWarningMessage(
                        "This student is already added to the class.",
                      );
                      setShowWarning(true);
                    } else {
                      if (checkForDuplicateStudents([student]).length > 0) {
                        setWarningMessage(
                          "This student is already enrolled in the current session. In order to add them, please remove them from the current classroom they are enrolled in.",
                        );
                        setShowWarning(true);
                      } else {
                        addClassroomStudent({
                          StudentID: student,
                          ClassroomID: classroom.ClassroomID,
                        }).then(() => {
                          // Update local state so future checks recognize this student as added
                          setStudentsList((prev) => [...prev, student]);

                          // Clear input and selection state
                          if (typeaheadRef.current) {
                            typeaheadRef.current.clear();
                          }
                          setStudent(-1);
                        });
                      }
                    }
                    // const arr = [...studentsList, student];
                    // if ([...new Set(arr)].length === studentsList.length) {
                    //   setWarningMessage(
                    //     "This student is already added to the class.",
                    //   );
                    //   setShowWarning(true);
                    // } else {
                    //   addClassroomStudent({
                    //     StudentID: student,
                    //     ClassroomID: classroom.ClassroomID,
                    //   });
                    //   // setEdit(false);
                    //   if (typeaheadRef.current) {
                    //     typeaheadRef.current.clear();
                    //   }
                    //   setStudent(-1);
                    // }
                  }}
                  disabled={student === -1}
                >
                  Submit
                </button>
              </div>
            )}
            {list.length > 0 ? (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th scope="col ">#</th>

                    <th scope="col ">First Name</th>
                    <th scope="col ">Last Name</th>

                    {edit && <th scope="col ">Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {list
                    .sort((a, b) => {
                      const nameA =
                        a.StudentName.toUpperCase() +
                        " " +
                        a.StudentLastName.toUpperCase();
                      const nameB =
                        b.StudentName.toUpperCase() +
                        " " +
                        b.StudentLastName.toUpperCase();
                      if (nameA < nameB) {
                        return -1;
                      }
                      if (nameA > nameB) {
                        return 1;
                      }
                      return 0;
                    })
                    .map((item, id) => {
                      return (
                        <tr key={id}>
                          <th scope="row">{id + 1}</th>

                          <td>{item.StudentName}</td>
                          <td>
                            {item.StudentLastName +
                              (item.AlternativeID !== null
                                ? ` - ${item.AlternativeID}`
                                : "")}
                          </td>
                          {edit && (
                            <td>
                              <div
                                className=""
                                onClick={() => {
                                  deleteClassroomStudent(
                                    item.ClassroomStudentID,
                                  ).then(() => {
                                    setStudentsList(
                                      studentsList.filter(
                                        (s) => s !== item.StudentID,
                                      ),
                                    );
                                    setList(
                                      list.filter(
                                        (student) =>
                                          item.ClassroomStudentID !==
                                          student.ClassroomStudentID,
                                      ),
                                    );
                                    // setEdit(false);
                                  });
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  fill="currentColor"
                                  class="bi bi-trash delete-item-btn rounded-circle border  border-2 p-2"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                  <path
                                    fill-rule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                  />
                                </svg>
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            ) : (
              <div className="">The Class in empty</div>
            )}{" "}
          </div>
        )}
        <div className="d-flex align-items-center justify-content-center gap-2">
          <button
            disabled={isLoadingValidateForm}
            type="submit"
            className="button-primary btn-block btn px-5"
          >
            {isLoadingValidateForm ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Loading
              </>
            ) : (
              <>Save</>
            )}
          </button>

          {parseInt(user.UserTypeID) > 2 &&
            classroom?.ClassroomID &&
            location.pathname.includes("edit") && (
              <>
                <Button
                  variant="danger"
                  className="d-flex align-items-center px-4"
                  onClick={() => setShowDeleteModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  Delete
                </Button>
              </>
            )}
          {/* Delete Modal */}
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Classroom</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete Classroom?</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="button-primary"
                onClick={() => {
                  deleteClassroom(classroom.ClassroomID);
                  hist.push("/admin/classrooms");
                  clearClassroom();
                  setShowDeleteModal(false);
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Warning Modal */}
          {showWarning && warningMessage && (
            <Modal
              show={showWarning}
              onHide={() => setShowWarning(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Warning</Modal.Title>
              </Modal.Header>
              <Modal.Body className="d-flex flex-column gap-2">
                {warningMessage.split("\n").map((line, idx) => (
                  <div key={idx}>{line}</div>
                ))}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setShowWarning(false);
                  }}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {/* Import Modal */}
          <Modal
            show={showImportModal}
            onHide={() => setShowImportModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Import Users</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                id="fileBulkUpload"
                type="file"
                accept=".xlsx"
                onChange={onChange}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowImportModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="button-primary"
                onClick={() => {
                  setShowImportModal(false);
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Confirmation Modal */}

          <Modal
            show={showConfirmModal}
            onHide={() => setShowConfirmModal(false)}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {location.pathname.includes("add")
                  ? "Confirm Classroom Creation"
                  : "Confirm Classroom Update"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="mb-3">
                <p className="text-muted">
                  Please review the classroom details before confirming the{" "}
                  {location.pathname.includes("add") ? "creation" : "update"}.
                </p>
              </div>

              {/* Section */}
              <div className="mb-3">
                <Form.Label>
                  <strong>Section</strong>
                </Form.Label>
                <div className="p-2 bg-light rounded">
                  {formData.Section || "Not specified"}
                </div>
              </div>

              {/* School */}
              {formData.SchoolID && (
                <div className="mb-3">
                  <Form.Label>
                    <strong>School</strong>
                  </Form.Label>
                  <div className="p-2 bg-light rounded">
                    {schoolsList?.find(
                      (school) =>
                        school.SchoolID === parseInt(formData.SchoolID),
                    )?.Name || "Unknown School"}
                  </div>
                </div>
              )}

              {/* Year */}
              <div className="mb-3">
                <Form.Label>
                  <strong>Academic Year</strong>
                </Form.Label>
                <div className="p-2 bg-light rounded">
                  {formData.Year
                    ? `${formData.Year - 1}-${formData.Year}`
                    : "Not specified"}
                </div>
              </div>

              {/* Grade */}
              <div className="mb-3">
                <Form.Label>
                  <strong>Grade</strong>
                </Form.Label>
                <div className="p-2 bg-light rounded">
                  {(() => {
                    const gradeNames = {
                      7: "Kindergarten",
                      1: "Grade 1",
                      2: "Grade 2",
                      3: "Grade 3",
                      4: "Grade 4",
                      5: "Grade 5",
                      6: "Grade 6",
                      8: "Grade 7",
                      9: "Grade 8",
                      10: "Other",
                    };
                    return gradeNames[formData.GradeID] || "Not specified";
                  })()}
                </div>
              </div>

              {/* Teacher */}
              <div className="mb-3">
                <Form.Label>
                  <strong>Teacher</strong>
                </Form.Label>
                <div className="p-2 bg-light rounded">
                  {(() => {
                    const teacher = usersList?.find(
                      (user) => user.UserID == formData.TeacherID,
                    );
                    return teacher
                      ? `${teacher.FirstName} ${teacher.LastName}${
                          teacher.AlternativeID
                            ? ` - ${teacher.AlternativeID}`
                            : ""
                        }`
                      : "Not specified";
                  })()}
                </div>
              </div>

              {/* Secondary Teacher */}
              <div className="mb-3">
                <Form.Label>
                  <strong>Secondary Teacher</strong>
                </Form.Label>
                <div className="p-2 bg-light rounded">
                  {(() => {
                    const teacher = usersList?.find(
                      (user) => user.UserID == formData.SecondaryTeacherID,
                    );
                    return teacher
                      ? `${teacher.FirstName} ${teacher.LastName}${
                          teacher.AlternativeID
                            ? ` - ${teacher.AlternativeID}`
                            : ""
                        }`
                      : "Not specified";
                  })()}
                </div>
              </div>

              {/* Remarks */}
              {formData.Remarks && (
                <div className="mb-3">
                  <Form.Label>
                    <strong>Remarks</strong>
                  </Form.Label>
                  <div className="p-2 bg-light rounded">{formData.Remarks}</div>
                </div>
              )}

              {/* Uploaded File Info */}
              {isBulkUpload && file && (
                <div className="mb-3">
                  <Form.Label>
                    <strong>Uploaded File</strong>
                  </Form.Label>
                  <div className="p-2 bg-light rounded">
                    {file.name} ({uploadedStudents.length} students)
                  </div>
                </div>
              )}

              {/* Selected Students (for manual selection) */}
              {location.pathname.includes("add") &&
                !isBulkUpload &&
                formData.Students &&
                formData.Students.length > 0 && (
                  <div className="mb-3">
                    <Form.Label>
                      <strong>
                        Selected Students ({formData.Students.length})
                      </strong>
                    </Form.Label>
                    <div
                      className="p-2 bg-light rounded"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      <div className="d-flex flex-wrap gap-1">
                        {formData.Students.map((studentId) => {
                          const student = usersList.find(
                            (s) => s.UserID === studentId,
                          );
                          return student ? (
                            <span
                              key={studentId}
                              className="badge me-1 mb-1"
                              style={{
                                backgroundColor: "#18a587",
                                color: "#ffffff",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                                padding: "0.5rem 0.75rem",
                                borderRadius: "0.375rem",
                              }}
                            >
                              {student.FirstName} {student.LastName}
                              {student.AlternativeID &&
                                ` - ${student.AlternativeID}`}
                            </span>
                          ) : null;
                        })}
                      </div>
                    </div>
                  </div>
                )}
              {/* 
              {location.pathname.includes("edit") &&
                !isBulkUpload &&
                formData.Students &&
                formData.Students.length > 0 && (
                  <div className="mb-3">
                    <Form.Label>
                      <strong>
                        Selected Students ({formData.Students.length})
                      </strong>
                    </Form.Label>
                    <div
                      className="p-2 bg-light rounded"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      <div className="d-flex flex-wrap gap-1">
                        {formData.Students.map((studentId) => {
                          console.log("test studentId", studentId);
                          const student = usersList.find(
                            (s) => s.UserID === studentId.StudentID
                          );
                          return student ? (
                            <span
                              key={studentId}
                              className="badge me-1 mb-1"
                              style={{
                                backgroundColor: "#18a587",
                                color: "#ffffff",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                                padding: "0.5rem 0.75rem",
                                borderRadius: "0.375rem",
                              }}
                            >
                              {student.FirstName} {student.LastName}
                              {student.AlternativeID &&
                                ` - ${student.AlternativeID}`}
                            </span>
                          ) : null;
                        })}
                      </div>
                    </div>
                  </div>
                )} */}

              {/* Uploaded Students Preview (for bulk upload) */}
              {location.pathname.includes("add") &&
                isBulkUpload &&
                uploadedStudents.length > 0 && (
                  <div className="mb-3">
                    <Form.Label>
                      <strong>
                        Students to be Added ({uploadedStudents.length})
                      </strong>
                    </Form.Label>
                    <div
                      className="p-2 bg-light rounded"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      <div className="d-flex flex-wrap gap-1">
                        {uploadedStudents.slice(0, 10).map((student, index) => (
                          <span
                            key={index}
                            className="badge me-1 mb-1"
                            style={{
                              backgroundColor: "#18a587",
                              color: "#ffffff",
                              fontSize: "0.875rem",
                              fontWeight: "600",
                              padding: "0.5rem 0.75rem",
                              borderRadius: "0.375rem",
                            }}
                          >
                            {student.col_1} {student.col_2} - {student.col_0}
                          </span>
                        ))}
                        {uploadedStudents.length > 10 && (
                          <span className="text-muted">
                            ... and {uploadedStudents.length - 10} more
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}

              {/* Enhanced Validation Results Section */}
              {warningMessage && (
                <div className="mb-3">
                  <div
                    className="card border-0 shadow-sm"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <div
                      className="card-header border-0"
                      style={{
                        backgroundColor: "#fff3cd",
                        borderBottom: "1px solid #ffeaa7",
                      }}
                    >
                      <h6
                        className="card-title mb-0 d-flex align-items-center"
                        style={{ color: "#856404" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="#f39c12"
                          className="bi bi-exclamation-triangle-fill me-2"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                        </svg>
                        Student Validation Warnings
                      </h6>
                    </div>
                    <div
                      className="card-body"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <div
                        className="validation-list"
                        style={{ maxHeight: "180px", overflowY: "auto" }}
                      >
                        {warningMessage.split("\n").map((line, idx) => (
                          <div
                            key={idx}
                            className="d-flex align-items-start mb-2 pb-2"
                          >
                            <span
                              className="flex-grow-1"
                              style={{
                                color: "#495057",
                                fontSize: "0.9rem",
                                lineHeight: "1.4",
                              }}
                            >
                              {line}
                            </span>
                          </div>
                        ))}
                      </div>
                      <hr className="my-3" style={{ borderColor: "#dee2e6" }} />
                    </div>
                  </div>
                </div>
              )}

              {/* Warning Message */}
              <div className="alert alert-info mt-4">
                <div className="d-flex align-items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#0c5460"
                    className="bi bi-info-circle-fill me-2 mt-1 flex-shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                  </svg>
                  <div>
                    <strong>Note:</strong>
                    <br />
                    {location.pathname.includes("add") ? (
                      <>
                        - Once created, the classroom can be edited later if
                        needed.
                        <br />
                        - Exactly matched students will not be re-created but
                        added to the class.
                        <br />- Closely matched and unmatched students will be
                        created and assigned to the class.
                      </>
                    ) : (
                      "The classroom information will be updated with the above details."
                    )}
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowConfirmModal(false);
                  setWarningMessage("");
                }}
              >
                Cancel
              </Button>
              <Button
                className="button-primary"
                onClick={handleConfirmSubmission}
              >
                {location.pathname.includes("add")
                  ? "Create Classroom"
                  : "Update Classroom"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </form>
    </div>
  );
};

ClassroomForm.propTypes = {
  classroom: PropTypes.object,
  user: PropTypes.object,
  schoolsList: PropTypes.array.isRequired,
  schoolListLoading: PropTypes.bool.isRequired,
  usersList: PropTypes.array.isRequired,
  usersListLoading: PropTypes.bool.isRequired,
  classroomLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  classroom: state.admin.classroom,
  user: state.auth.user,
  schoolsList: state.admin.schoolsList,
  schoolListLoading: state.admin.schoolListLoading,
  usersList: state.admin.usersList,
  usersListLoading: state.admin.usersListLoading,
  classroomLoading: state.admin.classroomLoading,
  schoolYears: state.admin.schoolYears,
});

export default connect(mapStateToProps, {
  loadClassroomsList,
  clearClassroom,
  updateClassroom,
  deleteClassroom,
  addClassroom,
  loadSchoolsList,
  loadUsersList,
  deleteClassroomStudent,
  addClassroomStudent,
  addClassroomStudents,
  validateUser,
  setAlert,
})(ClassroomForm);
